import { DEFAULT_LOGIN_REDIRECT } from "@/routes";

export function resolvePostLoginRedirect(callbackUrl?: string | null): string {
  if (!callbackUrl) {
    return DEFAULT_LOGIN_REDIRECT;
  }

  if (
    callbackUrl.startsWith("http://") ||
    callbackUrl.startsWith("https://") ||
    callbackUrl.startsWith("//")
  ) {
    return DEFAULT_LOGIN_REDIRECT;
  }

  if (callbackUrl.startsWith("/auth/")) {
    return DEFAULT_LOGIN_REDIRECT;
  }

  if (!callbackUrl.startsWith("/")) {
    return DEFAULT_LOGIN_REDIRECT;
  }

  return callbackUrl;
}
